/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'
import styles from './view.module.css'
import { DialogOverlay as ViewsModalOverlay, DialogContent as ViewsModalOverlayContent } from '@reach/dialog'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Loading",
  isOpen
  
}) {
  return (<React.Fragment
>
<ViewsModalOverlay
  data-testid="Loading.Horizontal"
  data-view-path={viewPath}
 isOpen={isOpen}
 className={`views-block ${styles.Horizontal}`}
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 borderBottomLeftRadius={4}
 borderBottomRightRadius={4}
 borderTopLeftRadius={4}
 borderTopRightRadius={4}
 height={8}
 width={300}
/>
</ViewsModalOverlay>
{children}
</React.Fragment>)
}